"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Address = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../utils");
var _SkeletonText = require("../../components/SkeletonText");
var _classnames = _interopRequireDefault(require("classnames"));
var _AddressModule = _interopRequireDefault(require("./Address.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Address = _ref => {
  var className = _ref.className,
    address = _ref.address;
  if (typeof address === 'string') {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _classnames.default)(_AddressModule.default.Container, className)
    }, (0, _utils.truncateAddress)(address));
  }
  var truncatedAddress;
  if (address !== null && address !== void 0 && address.text) {
    truncatedAddress = (0, _utils.truncateAddress)(address === null || address === void 0 ? void 0 : address.text);
  }
  return /*#__PURE__*/_react.default.createElement(_SkeletonText.SkeletonText, {
    className: (0, _classnames.default)(_AddressModule.default.AsyncAddress, className),
    as: 'span',
    asyncText: _objectSpread(_objectSpread({}, address), {}, {
      text: truncatedAddress
    })
  });
};
exports.Address = Address;
//# sourceMappingURL=Address.js.map